module.exports = __webpack_public_path__ + "static/img/9_IMG_20151229_150242.54e15248.jpg";